import { FeedbackCategory, FeedbackDialogParams, FeedbackRibbon } from 'owa-feedback';
import loc from 'owa-localize';
import React from 'react';
import {
    sonoraFeedbackRibbonMessage,
    sonoraFeedbackRibbonMoreMessage,
    sonoraFeedbackRibbonThankYouMessage,
    sonoraInlineFeedbackDialogTitle,
    sonoraInlineFeedbackDialogSubtitle,
    sonoraInlineFeedbackDialogTextFieldPlaceholder,
    sonoraInlineFeedbackDialogOption1,
    sonoraInlineFeedbackDialogOption2,
    sonoraInlineFeedbackDialogOption3,
    sonoraInlineFeedbackDialogOption4,
    sonoraInlineFeedbackDialogOption5,
    sonoraInlineFeedbackDialogOption6,
    sonoraInlineFeedbackDialogEntityAll,
    sonoraInlineFeedbackDialogEntityNotes,
    sonoraInlineFeedbackDialogEntityFiles,
    sonoraInlineFeedbackDialogEntityMeetingTime,
} from './SonoraInlineFeedbackDialog.locstring.json';
import { SonoraEntityType } from 'owa-editor-sonora-types';
import { SONORA_FEATURE_NAME } from '../constants';

import sonoraCommonStyles from './SonoraCommonStyles.scss';

interface SonoraFeedbackRibbonProps {
    sonoraDisplayedSuggestionTypes: SonoraEntityType[];
    otherDisplayedSuggestionFeedbackCategories?: FeedbackCategory[];
    pluginName: string;
}

const SonoraFeedbackRibbon = (props: SonoraFeedbackRibbonProps): JSX.Element => {
    const {
        sonoraDisplayedSuggestionTypes,
        otherDisplayedSuggestionFeedbackCategories,
        pluginName,
    } = props;

    const feedbackCategories: FeedbackCategory[] = [
        {
            logString: 'Useful',
            uiString: loc(sonoraInlineFeedbackDialogOption1),
        },
        {
            logString: 'Not relevant',
            uiString: loc(sonoraInlineFeedbackDialogOption2),
        },
        {
            logString: "Item I was looking for wasn't in the results",
            uiString: loc(sonoraInlineFeedbackDialogOption3),
        },
        {
            logString: "Doesn't save me time",
            uiString: loc(sonoraInlineFeedbackDialogOption4),
        },
        {
            logString: 'Hard to use',
            uiString: loc(sonoraInlineFeedbackDialogOption5),
        },
        {
            logString: 'Other',
            uiString: loc(sonoraInlineFeedbackDialogOption6),
        },
    ];

    const feedbackSubCategories: FeedbackCategory[] = [
        {
            logString: 'General feedback',
            uiString: loc(sonoraInlineFeedbackDialogEntityAll),
        } as FeedbackCategory,
        ...(otherDisplayedSuggestionFeedbackCategories ?? []),
    ];

    sonoraDisplayedSuggestionTypes.forEach(type => {
        feedbackSubCategories.push({
            logString: SonoraEntityType[type],
            uiString: getLocalizedStringForSuggestionTypes(type),
        } as FeedbackCategory);
    });

    const feedbackDialogParams: FeedbackDialogParams = {
        title: loc(sonoraInlineFeedbackDialogTitle),
        subTitle: loc(sonoraInlineFeedbackDialogSubtitle),
        categories: feedbackCategories,
        subCategories: feedbackSubCategories,
        ghostText: loc(sonoraInlineFeedbackDialogTextFieldPlaceholder),
    };

    return (
        <div className={sonoraCommonStyles.feedbackRibbonContainer}>
            <FeedbackRibbon
                ribbonMessageClassName={sonoraCommonStyles.feedbackRibbon}
                ribbonMessage={loc(sonoraFeedbackRibbonMessage)}
                moreFeedbackRibbonMessage={loc(sonoraFeedbackRibbonMoreMessage)}
                thankYouMessage={loc(sonoraFeedbackRibbonThankYouMessage)}
                feature={SONORA_FEATURE_NAME}
                subFeature={pluginName}
                noFeedbackDialogParams={feedbackDialogParams}
            />
        </div>
    );
};

export default SonoraFeedbackRibbon;

const getLocalizedStringForSuggestionTypes = (type: SonoraEntityType): string => {
    switch (type) {
        case SonoraEntityType.StickyNotes:
            return loc(sonoraInlineFeedbackDialogEntityNotes);
        case SonoraEntityType.File:
            return loc(sonoraInlineFeedbackDialogEntityFiles);
        case SonoraEntityType.MeetingTimes:
            return loc(sonoraInlineFeedbackDialogEntityMeetingTime);
        default:
            return '';
    }
};
